<template>
  <div class="map-controls">
    <div class="map-type-control">
      <div class="radio-group">
        <label class="radio-label">
          <input
            type="radio"
            name="mapProvider"
            value="yandex"
            :checked="selectedMapProvider === 'yandex'"
            @change="changeMapProvider('yandex')"
          />
          <span class="radio-text">Яндекс</span>
        </label>
        <label class="radio-label">
          <input
            type="radio"
            name="mapProvider"
            value="google"
            :checked="selectedMapProvider === 'google'"
            @change="changeMapProvider('google')"
          />
          <span class="radio-text">Google</span>
        </label>
      </div>
      <div class="divider"></div>
      <div class="radio-group">
        <label class="radio-label">
          <input
            type="radio"
            name="mapTheme"
            value="light"
            :checked="!isDarkTheme || !theme_map_dark"
            @change="changeMapTheme(false)"
          />
          <span class="radio-text">Светлая</span>
        </label>
        <label class="radio-label">
          <input
            type="radio"
            name="mapTheme"
            value="dark"
            :checked="isDarkTheme || theme_map_dark"
            @change="changeMapTheme(true)"
          />
          <span class="radio-text">Темная</span>
        </label>
      </div>
      <div v-if="props.mapProvider === 'yandex'" class="map-options">
        <div class="map-option" style="display: none!important"> <!-- парковки скрыты -->
          <label>
            <span>Парковки</span>
            <input
                type="checkbox"
                :checked="showParking"
                @change="toggleParking"
                class="custom-checkbox"
            />
          </label>
        </div>
        
        <div class="map-option">
          <label>
            <span>Пробки</span>
            <input
              type="checkbox"
              :checked="showTraffic"
              @change="toggleTraffic"
              class="custom-checkbox"
            />
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, defineEmits, defineProps } from "vue";

const props = defineProps({
  trafficEnabled: {
    type: Boolean,
    default: false,
  },
  parkingEnabled: {
    type: Boolean,
    default: false,
  },
  isDarkTheme: {
    type: Boolean,
    default: false,
  },
  mapProvider: {
    type: String,
    default: "yandex",
  },
});

const emit = defineEmits([
  "toggleTraffic",
  "toggleParking",
  "changeMapTheme",
  "changeMapProvider",
]);

const showTraffic = ref(props.trafficEnabled);
const showParking = ref(props.parkingEnabled);
const isDarkTheme = ref(props.isDarkTheme);
const selectedMapProvider = ref(props.mapProvider);
const theme_map_dark =
  localStorage.getItem("card_theme") === "dark" ||
  localStorage.getItem("theme") === "dark";

function toggleTraffic(event) {
  showTraffic.value = event.target.checked;
  emit("toggleTraffic", showTraffic.value);
}

function toggleParking(event) {
  showParking.value = event.target.checked;
  emit("toggleParking", showParking.value);
}

function changeMapTheme(isDark) {
  localStorage.setItem("card_theme", isDark ? "dark" : "light");
  emit("changeMapTheme", isDark);
}

function changeMapProvider(provider) {
  selectedMapProvider.value = provider;
  emit("changeMapProvider", provider);
}
watch(
  () => props.trafficEnabled,
  (newValue) => {
    showTraffic.value = newValue;
  }
);
watch(
  () => props.isDarkTheme,
  (newValue) => {
    isDarkTheme.value = newValue;
  }
);
watch(
  () => props.parkingEnabled,
  (newValue) => {
    showParking.value = newValue;
  }
);
watch(
  () => props.mapProvider,
  (newValue) => {
    selectedMapProvider.value = newValue;
  }
);
onMounted(() => {
  showTraffic.value = props.trafficEnabled;
  showParking.value = props.parkingEnabled;
  selectedMapProvider.value = props.mapProvider;

  const savedTheme = localStorage.getItem("card_theme");
  if (savedTheme) {
    const isDark = savedTheme === "dark";
    if (isDark !== isDarkTheme.value) {
      emit("changeMapTheme", isDark);
    }
  }
});
</script>

<style scoped>
.map-controls {
  position: absolute;
  top: 96px;
  right: 80px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
}

.map-type-control {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  width: 180px;
}
.map-options {
  border-top: 1px solid #f6f6f6;
  padding: 10px 15px;
}

.map-option label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.divider {
  width: 100%;
  border-top: 1px solid #f6f6f6;
}

.radio-group {
  padding: 10px 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.radio-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.radio-label input {
  margin-right: 8px;
}

.radio-text {
  color: #4d5460;
}

.custom-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
</style>
